import { render, staticRenderFns } from "./CryptointerceptorDetailModal.vue?vue&type=template&id=c0cbd80c&scoped=true&"
import script from "./CryptointerceptorDetailModal.vue?vue&type=script&lang=js&"
export * from "./CryptointerceptorDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CryptointerceptorDetailModal.vue?vue&type=style&index=0&id=c0cbd80c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cbd80c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VDivider,VIcon,VProgressLinear,VSpacer})
